// auto initialization
init();


function init() {
  const toggles = document.getElementsByClassName('drawer-toggle');
  const numToggles = toggles.length;
  for (let i = 0; i < numToggles; i++) {
    const t = toggles[i];
    t.addEventListener('click', onToggleClicked);
  }
}

function onToggleClicked(event) {
  const toggle = event.target;

  // update drawer props
  const drawer = toggle.closest('.link-in-drawer');
  const isExpanded = drawer.dataset.expanded === true || drawer.dataset.expanded === 'true';
  const newState = !isExpanded;
  drawer.dataset.expanded = newState;

  // update toggle props
  toggle.setAttribute('aria-expanded', newState)
}
